import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-add-phase',
    templateUrl: './add-phase.component.html',
    styleUrls: ['./add-phase.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddPhaseComponent implements OnInit {

	@Input() phase: any;
	@Input() project: any;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	formData: any = {
		'id': null,
		'phase_id': null,
		'week': null,
		'date_start': null
	}

	submitForm() {
		this.loading = true;
		this._tS.createPhaseProject(this.project.id, this.formData).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		)
	}

	close() {
		this.closeView.emit()
	}

	fillForm() {
		this.formData.id = this.phase.id;
		this.formData.phase_id = this.phase.phase_id;
		this.formData.week = this.phase.week;
		this.formData.date_start = this.phase.date_start;
	}

	phaseHasOnlyWeeks() {
		return this.phase.phase_id == 3 || this.phase.phase_id == 4;
	}

	constructor(public _gS: GlobalService, private _tS: TimelineService) { }

	ngOnInit() {
		if (this.phase) {
			this.fillForm();
		}
	}

}
